import { H2, H6, SmallButton } from "@sellar-io/components";
import { PriceTierOrderRule } from "@sellar-io/api-v2/types";
import { List, ListElement } from "../../../../components";
import { generatePriceTierOrderRuleDescription } from "../../../../utils/sellarHelpers";
import { useState } from "react";
import { PriceTierOrderRuleDialogCreate } from "./PriceTierOrderRuleDialog/PriceTierOrderRuleDialogCreate";
import { PriceTierOrderRuleDialogUpdate } from "./PriceTierOrderRuleDialog/PriceTierOrderRuleDialogUpdate";

export const PriceTierOrderRulesEdit = ({
  priceTierId,
  orderRulesId,
  rules,
}: {
  priceTierId: number;
  orderRulesId: number | null;
  rules: Pick<PriceTierOrderRule, "id" | "itemType" | "quantity">[];
}) => {
  const [dialogActive, setDialogActive] = useState(false);

  return (
    <div className={"flex flex-col gap-2"}>
      <div>
        <H2>Minimum order quantities</H2>

        <H6>
          When setting multiple minimum order quantities, only one has to be
          met.
        </H6>
      </div>

      {!rules.length ? (
        <div>No minimum item quantity rules</div>
      ) : (
        <List>
          {rules.map((rule) => (
            <PriceTierOrderRuleListElement rule={rule} key={rule.id} />
          ))}
        </List>
      )}

      <PriceTierOrderRuleDialogCreate
        priceTierId={priceTierId}
        orderRulesId={orderRulesId}
        active={dialogActive}
        onDismiss={() => setDialogActive(false)}
      />

      <SmallButton
        onClick={() => {
          setDialogActive(true);
        }}
      >
        Add minimum order rule
      </SmallButton>
    </div>
  );
};

const PriceTierOrderRuleListElement = ({
  rule,
}: {
  rule: Pick<PriceTierOrderRule, "id" | "itemType" | "quantity">;
}) => {
  const [editDialogActive, setEditDialogActive] = useState(false);

  return (
    <>
      <ListElement
        promptText={"Edit"}
        onClick={() => {
          setEditDialogActive(true);
        }}
      >
        {generatePriceTierOrderRuleDescription(rule)}
      </ListElement>
      <PriceTierOrderRuleDialogUpdate
        priceTierOrderRule={rule}
        active={editDialogActive}
        onDismiss={() => setEditDialogActive(false)}
      />
    </>
  );
};
